import React from 'react';
import { CtaButton } from './CtaButton';
import { ShieldCheck, Clock, Zap, Lock, CheckCircle, Tag } from 'lucide-react';
export function FinalCtaSection() {
  return <section id="oferta-final" className="py-4 md:py-14 px-6 bg-navy text-center border-t border-white/10" data-id="element-58">
      <div className="max-w-3xl mx-auto" data-id="element-59">
        {/* Urgency Badge */}
        <div className="inline-flex items-center gap-2 bg-amber/20 text-amber px-4 py-2 rounded-full text-sm font-bold uppercase tracking-wider mb-8" data-id="element-60">
          <Clock className="w-4 h-4" data-id="element-61" />
          <span data-id="element-62">Oferta por tiempo limitado</span>
        </div>

        {/* Emotional Headline */}
        <h2 className="text-4xl md:text-5xl font-bold text-background mb-6 leading-tight" data-id="element-63">
          Cada día que pasa, tu cuerpo sigue{' '}
          <span className="text-amber font-semibold" data-id="element-64">acumulando daño</span>.
        </h2>

        <p className="text-xl md:text-2xl text-background/80 mb-4 max-w-2xl mx-auto leading-relaxed" data-id="element-65">
          Mañana te vas a{' '}
          <strong className="text-background" data-id="element-66">
            despertar igual de cansado
          </strong>
          . La <strong className="text-background" data-id="element-67">niebla mental</strong> no se
          va sola. El{' '}
          <strong className="text-background" data-id="element-68">peso no cede solo</strong>.
        </p>

        <p className="text-xl text-amber font-semibold mb-10 max-w-2xl mx-auto" data-id="element-69">
          Pero en <strong data-id="element-70">72 horas</strong>,{' '}
          <strong data-id="element-71">todo puede ser diferente</strong>.
        </p>

        {/* Value Stack */}
        <div className="bg-white/5 border border-white/10 rounded-2xl p-8 mb-10 text-left max-w-xl mx-auto" data-id="element-72">
          <p className="text-background/60 text-sm uppercase tracking-wider font-bold mb-4" data-id="element-73">
            Lo que recibís hoy:
          </p>
          <ul className="space-y-3 mb-6" data-id="element-74">
            <li className="flex items-center gap-3 text-background/90" data-id="element-75">
              <CheckCircle className="w-5 h-5 text-accent flex-shrink-0" data-id="element-76" />
              <span data-id="element-77">El Protocolo de Reinicio Biológico completo</span>
            </li>
            <li className="flex items-center gap-3 text-background/90" data-id="element-78">
              <CheckCircle className="w-5 h-5 text-accent flex-shrink-0" data-id="element-79" />
              <span data-id="element-80">
                Guía paso a paso para las primeras{' '}
                <strong className="text-background" data-id="element-81">72 horas</strong>
              </span>
            </li>
            <li className="flex items-center gap-3 text-background/90" data-id="element-82">
              <CheckCircle className="w-5 h-5 text-accent flex-shrink-0" data-id="element-83" />
              <span data-id="element-84">
                El secreto de "La Bóveda de Energía" para quemar grasa sin
                hambre
              </span>
            </li>
            <li className="flex items-center gap-3 text-background/90" data-id="element-85">
              <CheckCircle className="w-5 h-5 text-accent flex-shrink-0" data-id="element-86" />
              <span data-id="element-87">
                El Interruptor de la Claridad para eliminar la neuro-inflamación
              </span>
            </li>
          </ul>

          {/* Pricing with Discount */}
          <div id="precio-final" className="border-t border-white/10 pt-6" data-id="element-88">
            <div className="flex flex-col items-center gap-3" data-id="element-89">
              <div className="flex items-center gap-3" data-id="element-90">
                <span className="text-background/40 text-xl line-through font-serif" data-id="element-91">
                  $18.862
                </span>
                <span className="bg-amber text-navy text-xs font-bold uppercase tracking-wider px-3 py-1 rounded-full flex items-center gap-1" data-id="element-92">
                  <Tag className="w-3 h-3" data-id="element-93" />
                  47% OFF
                </span>
              </div>
              <div className="flex items-baseline gap-2" data-id="element-94">
                <span className="text-background/50 text-sm" data-id="element-95">
                  Hoy por solo:
                </span>
                <span className="text-amber font-bold text-5xl font-serif" data-id="element-96">
                  <strong data-id="element-97">$9.997</strong>
                </span>
              </div>
              <p className="text-accent text-sm font-medium mt-1" data-id="element-98">
                Ahorrás $8.865 con esta oferta
              </p>
            </div>
          </div>
        </div>

        {/* CTA Button */}
        <CtaButton href="https://vitalfoco.com/cart/44177187733564:1" className="w-full md:w-auto text-xl py-6 px-12 shadow-2xl shadow-amber/20" data-id="element-99">
          DESCARGAR EL MÉTODO COMPLETO
        </CtaButton>

        {/* Trust Signals */}
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-6 text-background/50 text-sm" data-id="element-100">
          <span className="flex items-center gap-2" data-id="element-101">
            <Lock className="w-4 h-4" data-id="element-102" />
            Pago 100% seguro
          </span>
          <span className="flex items-center gap-2" data-id="element-103">
            <Zap className="w-4 h-4" data-id="element-104" />
            Acceso inmediato
          </span>
          <span className="flex items-center gap-2" data-id="element-105">
            <ShieldCheck className="w-4 h-4" data-id="element-106" />
            Garantía de 7 días
          </span>
        </div>

        {/* Risk Reversal */}
        <div className="mt-10 bg-accent/10 border border-accent/20 rounded-xl p-6 max-w-xl mx-auto text-left" data-id="element-107">
          <div className="flex items-start gap-4" data-id="element-108">
            <ShieldCheck className="w-10 h-10 text-accent flex-shrink-0 mt-1" data-id="element-109" />
            <div data-id="element-110">
              <p className="text-background font-bold mb-1" data-id="element-111">
                Riesgo cero. Garantía total.
              </p>
              <p className="text-background/70 text-sm leading-relaxed" data-id="element-112">
                Si en <strong className="text-background" data-id="element-113">72 horas</strong> no
                sentís que la{' '}
                <strong className="text-background" data-id="element-114">niebla mental</strong> se
                levantó y tu energía no mejoró, te devuelvo cada centavo. Sin
                preguntas. Sin complicaciones.
              </p>
            </div>
          </div>
        </div>

        {/* Final Scarcity Line */}
        <p className="mt-10 text-background/40 text-sm italic" data-id="element-115">
          No sé cuánto tiempo más estará disponible a este precio. Si estás
          leyendo esto, todavía estás a tiempo.
        </p>
      </div>
    </section>;
}